import cookie from 'js-cookie';
import useragent from '@finance/useragent';
import { APP, RUN_APP } from '../env';
import copy from './copy';
import urlParams from './url-params';
/** 协议列表 */
const scheme = [
    'https://t.cardniu.com',
    'https://t.feidee.com',
    'cardniu://',
    'feidee://',
    'fdmoneyall://',
    'FDMoneyAny://',
    'fdmoneyany://',
];
/** 检测携带协议的正则 */
const re = new RegExp('^(' + scheme.map(e => `(${e.replace(/([/.])/g, '\\$1')})`).join('|') + ')');
/** 卡牛新建webview前缀 */
const knWebviewPre = 'https://t.cardniu.com/applyloan?url=';
/** 随手记新建webview前缀 */
const ssjWevbiewjPre = 'https://t.feidee.com/financeWeb?url=';
const isEmptyObject = o => JSON.stringify(o) === "{}";
const INNER_MEDIA = 'inner_media';
const pickInnerParamsFromPageURL = (transferInnerKey) => {
    const ret = {};
    if (transferInnerKey.length) {
        const all = urlParams();
        transferInnerKey.forEach(key => {
            switch (key) {
                case INNER_MEDIA:
                    ret[INNER_MEDIA] = all[INNER_MEDIA] || cookie.get('lc_inner_media') || '';
                    break;
                default:
                    ret[key] = all[key] || '';
                    break;
            }
        });
    }
    return ret;
};
const href = (_url) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            window.location.href = _url;
            resolve();
        }, 0);
    });
};
const windowOpen = (url = window.location.href, { app = RUN_APP, target = 'webview', extParams = null, transferInnerKey = [INNER_MEDIA] } = {}) => {
    const isScheme = re.test(url);
    let _url = url;
    if ((extParams || transferInnerKey.length) && !isScheme) {
        const params = {
            ...pickInnerParamsFromPageURL(transferInnerKey),
            ...(extParams || {})
        };
        if (!isEmptyObject(params)) {
            _url = urlParams(params, _url, { merge: true });
        }
    }
    // 不需要新开webview
    if (target !== 'webview') {
        return href(_url);
    }
    // 新开webview
    // 如果是非协议的url，则拼接新开webview前缀
    if (!isScheme) {
        const kn = useragent.isKaniu ? APP.kn : '';
        const ssj = useragent.isSuishouji ? APP.ssj : '';
        const target = app || kn || ssj;
        const pre = target === APP.kn
            ? knWebviewPre
            : ssjWevbiewjPre;
        _url = pre + encodeURIComponent(_url);
    }
    // h5端执行copy操作
    if (!useragent.isKaniu && !useragent.isSuishouji) {
        copy(`§${_url}§`);
    }
    return href(_url);
};
export default windowOpen;
